import { SessionStepModelsState } from '@/pages/session-apply/models/stepModels';

export interface FosterStepModelsState {
  step: number;
  maxStep: number;
}

const initialState: FosterStepModelsState = {
  step: 1,
  maxStep: 1,
};

export default {
  namespace: 'fosterStepModels',
  state: initialState,
  reducers: {
    updateStep(state: FosterStepModelsState, step: number) {
      return {
        ...state,
        step,
      };
    },
    update: (state: SessionStepModelsState, { payload }: { payload: Partial<SessionStepModelsState> }) => ({
      ...state,
      ...payload,
    }),
    updateMaxStep(state: FosterStepModelsState, maxStep: number) {
      return {
        ...state,
        maxStep,
      };
    },
    reset() {
      return initialState;
    },
  },
};
